// Token storage. Access + refresh tokens live in localStorage.
// (Trade-off: simple cross-origin dev flow; production should prefer an
// httpOnly refresh cookie behind a same-site gateway.)
const ACCESS_KEY = 'sabia.accessToken';
const REFRESH_KEY = 'sabia.refreshToken';

export const tokens = {
  get access() {
    return localStorage.getItem(ACCESS_KEY);
  },
  get refresh() {
    return localStorage.getItem(REFRESH_KEY);
  },
  set({ accessToken, refreshToken }) {
    if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
  get isAuthenticated() {
    return !!localStorage.getItem(ACCESS_KEY);
  },
};
